export default __webpack_public_path__ + "assets/webgl/LightCone.122e1325.gltf";